<template>
  <div>
    <loading
      :active.sync="listing_existing_loading"
      :is-full-page="false"
    />
    <v-server-table
      class="pt-0"
      ref="tableExisting"
      :name="'attachment/attachmentTable'"
      :columns="listing_existing_columns"
      :options="listing_existing_options({ [parentType == 'company' ? 'company_id' : (parentType == 'person' ? 'person_id' : (parentType == 'alert' ? 'alert_id' : 'all'))]: parentId })"
    >
      <div slot="afterFilterWrapper">
        <!-- <v-btn
          color="primary"
          class="mr-3"
          outlined
          @click="onUploadClick"
          :loading="file_selecting || uploading"
          data-cy="upload_att_btn"
        >
          <v-icon left>
            mdi-plus
          </v-icon>
          {{ $t('attachment.listing.buttons.add') }}
        </v-btn>
        <input
          ref="uploader"
          class="d-none"
          type="file"
          accept="*/*"
          @change="onFileChanged"
          v-if="file_selecting"
        > -->
        <!-- Alternative Vuetify file input for better compatibility -->
        <v-file-input
          v-if="!file_selecting"
          v-model="file_selected_vuetify"
          accept="*/*"
          label="Or select file here"
          prepend-icon="mdi-paperclip"
          outlined
          dense
          hide-details
          @change="onFileChangedVuetify"
          class="mt-2"
          style="max-width: 300px;"
        />
      </div>
      <div
        slot="file_name"
        slot-scope="props"
      >
        <v-checkbox
          v-if="mode == 'selecting'"
          v-model="selected_items_local"
          multiple
          :key="props.row.id"
          :disabled="!!unselectable(props.row)"
          :messages="unselectable(props.row) || ''"
          @change="onSelect"
          :value="props.row.id"
          :label="props.row.file_name"
        >
          <template v-slot:label>
            {{ props.row.file_name }}
          </template>
        </v-checkbox>
        <span v-else>{{ props.row.file_name }}</span>
      </div>
      <div
        slot="create_date"
        slot-scope="props"
      >
        <DateFormat
          :date="props.row.create_date"
          :showtime="true"
        />
      </div>
      <div
        slot="description"
        slot-scope="props"
      >
        <TextareaSafeDisplay :value="props.row.description" />
      </div>
      <div
        slot="action"
        slot-scope="props"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              class="ml-1"
              @click="view_document(props.row)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('attachment.listing.buttons.preview') }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              class="ml-1"
              @click="download_document(props.row)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('attachment.listing.buttons.download') }}</span>
        </v-tooltip>
      </div>
    </v-server-table>
    <v-dialog
      v-model="dialog_upload"
      width="500"
    >
      <v-card :loading="uploading">
        <v-card-title>
          {{ $t('attachment.listing.buttons.add') }}
          <v-spacer />
          <v-btn
            @click="onUpload"
            outlined
            color="primary"
            :loading="uploading"
          >
            <v-icon left>
              mdi-upload
            </v-icon>
            {{ $t('attachment.listing.buttons.upload') }}
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="3">
              {{ $t('attachment.listing.table.file_name.label') }}
            </v-col>
            <v-col
              cols="auto"
              class="primary--text"
            >
              {{ file_selected ? file_selected.name : '' }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                :label="$t('attachment.listing.table.description.label')"
                v-model="file_description"
                auto-grow
                rows="1"
                row-height="15"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import DateFormat from '@/components/common/DateFormat'
import TextareaSafeDisplay from '@/components/common/TextareaSafeDisplay'

export default {
  props: {
    parentId: {
      type: [String, Number],
      required: true
    },
    parentType: {
      type: String,
      required: true,
      default: 'all',
      validator: function (value) {
        // The value must match one of these strings
        return ['company', 'person', 'alert', 'all'].indexOf(value) !== -1
      }
    },
    mode: {
      type: String,
      default: 'editing',
      validator: function (value) {
        // The value must match one of these strings
        return ['selecting', 'editing'].indexOf(value) !== -1
      }
    },
    selectedItems: { // for "selecting" mode only
      type: Array,
      default: () => ([])
    },
    unselectable: {
      type: Function,
      default: (unusedItem) => {
        return false
      }
    }
  },
  components: {
    DateFormat,
    TextareaSafeDisplay
  },
  computed: {
    ...mapState('attachment', {
      listing_existing_loading: state => state.listing.requestLoading,
      listing_existing_columns: state => state.listing.columns
    }),
    ...mapGetters('attachment', {
      listing_existing_options: 'options'
    })
  },
  data () {
    return {
      // upload
      file_selected: null,
      file_selected_vuetify: null,
      file_description: '',
      file_selecting: false,
      uploading: false,
      dialog_upload: false,
      // selecting mode
      selected_items_local: []
    }
  },
  methods: {
    onFileChanged (e) {
      console.log('onFileChanged triggered:', e)
      console.log('Event target:', e.target)
      console.log('Files:', e.target.files)
      this.file_selected = e.target.files[0]
      this.file_selecting = false // Reset selecting state when file is chosen
      console.log('File selected via input:', this.file_selected)
      // upload
      if (this.file_selected) {
        console.log('Opening upload dialog')
        this.dialog_upload = true
      }
    },
    onFileChangedVuetify (file) {
      console.log('Vuetify file input changed:', file)
      this.file_selected = file
      this.file_selected_vuetify = file
      if (file) {
        console.log('File selected via Vuetify:', file.name)
        this.dialog_upload = true
      }
    },
    onUploadClick () {
      console.log('Upload button clicked')
      console.log('Current file_selecting state:', this.file_selecting)
      console.log('Uploader ref before setting state:', this.$refs.uploader)

      this.file_selecting = true

      this.$nextTick(() => {
        console.log('In nextTick - about to click file input')
        console.log('Uploader ref in nextTick:', this.$refs.uploader)

        this.file_selected = null
        this.file_selected_vuetify = null

        // Use a timeout as fallback to reset file_selecting
        setTimeout(() => {
          if (this.file_selecting && !this.file_selected) {
            console.log('Timeout: No file selected, resetting state')
            this.file_selecting = false
          }
        }, 2000) // Increased timeout to 2 seconds

        if (this.$refs.uploader) {
          console.log('Clicking file input')
          try {
            this.$refs.uploader.click()
            console.log('Click triggered successfully')
          } catch (error) {
            console.error('Error clicking file input:', error)
            this.file_selecting = false
          }
        } else {
          console.error('Uploader ref not found!')
          this.file_selecting = false
        }
      })
    },
    onUpload () {
      this.uploading = true
      console.log('Uploading file:', this.file_selected)
      this.$store.dispatch('attachment/upload', {
        file: this.file_selected,
        description: this.file_description,
        ...(this.parentType !== 'all' ? { [`${this.parentType}_ids`]: this.parentId } : {})
      })
        .then((results) => {
          if (results.status === 200 && results.data) {
            this.$refs.tableExisting.getData()

            this.$emit('reload')

            return this.$notify({
              type: 'success',
              title: 'File Upload',
              text: 'The file uploaded successfully'
            })
          } else {
            this.$notify({
              type: 'error',
              title: 'File Upload',
              text: 'Failed to upload file'
            })
          }
        }).catch((error) => {
          if (error.response) {
            // console.log(error.response)
            this.$notify({
              type: 'error',
              title: 'File Upload',
              text: error.response.data.message || error.message
            })
          } else {
            this.$notify({
              type: 'error',
              title: 'File Upload',
              text: error.message
            })
          }
        }).finally(() => {
          this.resetFileInput()
          this.file_selected = null
          this.file_selected_vuetify = null
          this.file_description = ''
          this.uploading = false
          this.dialog_upload = false
        })
    },
    resetFileInput () {
      // Reset the file input value to allow selecting the same file again
      if (this.$refs.uploader) {
        this.$refs.uploader.value = ''
      }
      this.file_selecting = false
    },
    onSelect (selected) {
      this.$emit('selected', selected)
    },
    view_document (attacmhent) {
      if (attacmhent) {
        window.open(attacmhent.view_path, '_blank')
      }
    },
    download_document (attacmhent) {
      if (attacmhent) {
        window.open(attacmhent.download_path, '_blank')
      }
    },
    handleVisibilityChange () {
      if (!document.hidden && this.file_selecting) {
        // User came back from file dialog, check if file was selected
        setTimeout(() => {
          if (this.file_selecting && !this.file_selected) {
            console.log('User returned from file dialog without selecting file')
            this.file_selecting = false
          }
        }, 100)
      }
    }
  },
  mounted () {
    this.selected_items_local = this.selectedItems
    console.log('Attachment component mounted')
    console.log('Browser support for file input:', 'click' in document.createElement('input'))

    // Add visibility change listener to detect when user comes back from file dialog
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  beforeDestroy () {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  }
}
</script>

<style>

</style>
